/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:32:54
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare کھولیں",
    name2: "ریزرویشن کروائیں",
    name3: "Carlcare کے ساتھ، آپ کسی بھی وقت اپنا آرڈر دیکھ سکتے ہیں۔",
    name4: "",
    name5: "دائیں طرف سلائیڈ کریں",
    name6: "توثیقی مکمل ہو گئی",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for Infinix/Tecno/itel designated models.",
    name11: "Starting from ₱500, you can get your battery replaced with no labor fee.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Flat Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    // name16: "Lower and Transparent Pricing",
    // name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy a 3-month warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. If you join the flat price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.",
    name31: "Carlcare Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "ڈیوائس کا ماڈل منتخب کریں",
    name2: "نقص کی تفصیل:",
    name3: "سروس اسٹور کو منتخب کرنے کے لیے ٹیپ کریں",
    name4: "سروس اسٹور:",
    name5: "ریزرویشن کا وقت:",
    name6: "براہِ کرم تفصیل میں اپنی ڈیوائس کے مسئلے کی وضاحت کریں!",
    name7: "آمد کا وقت منتخب کرنے کے لیے ٹیپ کریں",
    name8: "براہ کرم اپنی رابطے کی درست تفصیلات درج کریں تاکہ ہم آپ سے رابطہ کر سکیں",
    name9: "دستیاب بکنگ کا وقت مندرجہ ذیل ہے",
    name10: "براہِ کرم اپنا فون نمبر درج کریں",
    name11: "قیمت",
    name12: "ذاتی معلومات:",
    name13: "براہِ کرم اپنا نام درج کریں",
    name14: "بھجوائیں",
    name15: "منسوخ کریں",
    name16: "ٹھیک ہے",
  },
  shops: {
    name1: "آپ کے منتخب کردہ برانڈ کی بنا پر، درج ذیل اسٹورز آپ کی خدمت کر سکتے ہیں!",
    name2: "مزید ریٹیل اسٹورز میں جلد آرہا ہے! ہمارے ساتھ رہیں!",
  },
  price: {
    name1: "برانڈ",
    name2: "ماڈل",
    name3: "آئٹم",
    name4: "قیمت",
    name5: "دوستانہ یاددہانی:",
    name6: "یہ قیمتیں صرف حوالے کے لیے ہیں، اور اصل قیمت آپ کی ڈیوائس کی حالت سے مشروط ہے۔",
    name7: "اگر کوئی خاص علامت نہیں ہے، تو قیمت کا یونٹ مقامی کرنسی یونٹ ہے۔",
    name8: "معذرت خواہ ہیں! موجودہ خطے میں قیمت کی کوئی معلومات دستیاب نہیں ہیں۔",
    name11:"مزدوری کی لاگت",
    name12:"کل قیمت",
    name13: "5. اگر مزدوری کا خرچ \"/\" ہے، تو اس کا مطلب یہ ہے کہ مزدوری کی لاگت کے لیے اسٹور سے مشورہ لینے کی ضرورت ہے۔",
    item_main_board: "مین بورڈ",
    item_screen_frame: "اسکرین (فریم)",
    item_screen_screen_frame: "سیکنڈری اسکرین (فریم)",
    item_touch_screen: "ٹچ اسکرین",
    item_camera: "کیمرہ",
    item_fixed_focus_camera: "فکسڈ فوکس کیمرہ",
    item_auto_focus_camera: "آٹو فوکس کیمرہ",
    item_screen: "اسکرین",
    item_secondary_screen: "سیکنڈری اسکرین",
    item_fingerprint_module: "فنگر پرنٹ ماڈیول",
    item_speaker: "اسپیکر",
    item_receiver: "ریسیور",
    item_small_board: "اسمال بورڈ",
    item_battery_cover: "بیٹری کور",
    item_battery: "بیٹری",
    item_charger: "چارجر",
    item_usb_cable: "\\u200fUSB کیبل\\u200f",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "کوئی مواد نہیں",
    name2: "سروس فراہم کنندگان:",
    name3: "سروس برانڈ:",
    name4: "ٹیلی فون:",
    name5: "آرڈر کی مقدار:",
    name6: "سروس کی درجہ بندی",
    name7: "سروس کا ماحول:",
    name8: "سروس کا رویہ:",
    name9: "سروس کی موثریت:",
    name10: "سروس کا معیار:",
    name11: "صارف کی تشخیص",
    name12:"تا",
    name13:"بند کر دیا گیا",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare کھولیں",
    name1: "براہ کرم ریزرویشن کی معلومات کا اسکرین شاٹ لیں اور ترجیحی سروس تک رسائی حاصل کرنے کے لیے اسے رسید کے طور پر محفوظ کریں",
    name2: "کامیابی سے درج ہو گیا",
    name3: "1۔ ڈیٹا کو صاف کریں",
    name4: "براہ کرم پہلے ہی اپنے فون پر ضروری نجی ڈیٹا کو بیک اپ کریں",
    name5: "2. پاور آن پاس ورڈ کو غیر فعال کریں",
    name6: "سروس اسٹور جانے سے قبل، براہ کرم",
    name7: "سروس اسٹور",
    name8: "ریزرویشن کا وقت",
    name9: "نقص کی تفصیل",
    name10: "ڈیوائس ماڈل",
    name11: "آرڈر نمبر ",
    name12: "آرڈر کی معلومات",
  },
  title: {
    
    name1: "مندرجہ ذیل ممالک کی معاونت کرتا ہے:",
    name2: "ماڈل منتخب کریں",
    name3: "ریزیرویشن",
    name4: "سروس اسٹور کی تفصیلات",
    name5: "سروس اسٹور کو منتخب کریں",
  },
  error: {
    
    name1: "کوئی ڈیٹا نہیں۔ براہِ کرم اپنی مرمت کی معلومات کی پڑتال کریں",
    name2: "مزید مدد درکار ہے؟ براہِ کرم ہم سے رابطہ کریں۔",
    name3: "معذرت خواہ ہیں ، موجودہ خطے میں کوئی Carlcare سنٹر نہیں ہے۔",
    name4: "براہ کرم پہلے سروس سینٹر کو منتخب کریں",
    name5: "ناکام ہو گیا",
    name6: "براہ کرم پہلے ڈیوائس کا ماڈل منتخب کریں",
    name7: "تفصیلات",
    name8: "براہِ کرم اپنی ضروریات کو تفصیل سے بیان کریں",
    name9: "",
  },
  add1:{
    "name0": "ur-rPK",
    "name1": "آپ کے آرڈر کی تصدیق ہو گئی ہے۔ ہمیں آپ کی آمد کا انتظار ہے۔",
    "name2": "شہرکا انتخاب",
    "name3": "براہ کرم %1$s ہندسوں کا فون نمبر درج کریں۔",
    "name4": "ہفتے کے دن کے اوقات",
    "name5": "پیر",
    "name6": "منگل",
    "name7": "بدھ",
    "name8": "جمعرات",
    "name9": "جمعہ",
    "name10": "ہفتہ",
    "name11": "اتوار",
    "name12": "ملک درج کریں اور تلاش کریں"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "دیگر",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ری ڈائریکٹ کرنے کے لیے تھپتھپائیں",
    name3:"آرڈر کی درجہ بندی کرنے کے لیے Carlcare ایپ کھولیں",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"سروس کو منتخب کریں",
    name7:"مفت صفائی",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "غلط معلومات",
    "cancelReason1": "وقت پر نہیں پہنچ سکتا",
    "cancelReason2": "ڈپلیکیٹ آرڈر/میرا آرڈر نہیں",
    "cancelReason3": "ناکامی بار بار نہیں ہوتی ہے",
    "cancelReason4": "صرف ٹیسٹ/انکوائری/ایونٹ/ کے لیے…",
    "cancelReason5": "زیادہ مہنگا",
    "cancelReason6": "مواد کی قلت",
    "cancelReason7": "کوئی مختلف خدمات نہیں",
    "cancelReason8": "اسٹور بہت دور ہے",
    "cancelReason9": "اسٹور بند ہے",
    "cancelReason10": "خدمات کا برا رویہ",
    "cancelReason11": "دوسرے برانڈز کے لیے تبدیلی/مرمت",
    "cancelReason12": "اسٹور نہیں مل سکا",
    "cancelReason13": "دیگر",
    "cancelOrder": "آرڈر منسوخ کریں",
    "reason_dialog_title": "براہ کرم ہمیں منسوخی کی وجہ بتائیں",
    "Cancel": "منسوخ کریں",
    "OK": "ٹھیک ہے",
    "name1": "توثیقی کوڈ درج کریں",
    "name2": "غلط تصدیقی کوڈ",
    "repair_reservation_detail_canceled": "یہ آرڈر منسوخ کردیا گیا ہے!",
    "purchase_cancel_dialog_content": "کیا آپ آرڈر منسوخ کرنے کی تصدیق کرتے ہیں؟",
    "yes": "ہاں",
    "no": "نہیں"
}
};
